import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SelectBox from "../../../components/SelectBox";
import {
  alertList,
  companyDetails,
  siteDetails,
} from "../../redux/api/dummyJson";
import { TableAlert } from "../../../components/Table/TableAlert";

const AlertTypes = ({
  selectedItem,
  setSelectedItem,
  site,
  setSite,
  comapanyList,
  getSiteList,
  siteList,
  getAlertTypes,
  setAlertData,
  alertData,
}) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);

  const [editIndex, setEditIndex] = useState(null);
  const [tempPriority, setTempPriority] = useState("");

  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");

  // ref for inputs
  const inputRefs = useRef({});

  console.log("company", selectedCompany);

  // Focus input automatically when editIndex changes
  useEffect(() => {
    if (editIndex !== null && inputRefs.current[editIndex]) {
      inputRefs.current[editIndex].focus();
    }
  }, [editIndex]);

  const handleChange = (event) => {
    const value = event.target.value;
    if (["1", "2", "3"].includes(value)) {
      setTempPriority(value);
    } else {
      setTempPriority("");
    }
  };

  const handleSave = (index) => {
    setAlertData((prev) => {
      const updated = [...prev];
      updated[index].priority = tempPriority || updated[index].priority;
      return updated;
    });
    setEditIndex(null);
    setTempPriority("");
  };

  const handleCancel = () => {
    setEditIndex(null);
    setTempPriority("");
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "sNo",
        Cell: ({ row }) => <p>{(page - 1) * 10 + row.index + 1}</p>,
      },
      {
        Header: "Alert List",
        accessor: "name",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: "Severity",
        accessor: "severity",
        Cell: ({ value, row }) => {
          const index = row.index;
          const isEditing = editIndex === index;

          return (
            <input
              className="input-box text-center w-50 f4"
              type="text"
              value={isEditing ? tempPriority : value} // <-- bind directly
              onChange={(e) => isEditing && handleChange(e)} // only handle when editing
              disabled={!isEditing}
              ref={(el) => {
                if (isEditing && el) el.focus(); // auto-focus when editing starts
              }}
            />
          );
        },
      },

      // {
      //     Header: "Edit (priority count)",
      //     accessor: "",
      //     Cell: ({ row }) => {
      //         const index = row.index;
      //         return (
      //             <div className="d-flex gap-2">
      //                 {editIndex === index ? (
      //                     <>
      //                         <button
      //                             onClick={() => handleSave(index)}
      //                             className="save-btn"
      //                         >
      //                             Save
      //                         </button>
      //                         <button
      //                             onClick={handleCancel}
      //                             className="cancel-btn"
      //                         >
      //                             Cancel
      //                         </button>
      //                     </>
      //                 ) : (
      //                     <button
      //                         onClick={() => {
      //                             setEditIndex(index);
      //                             setTempPriority(alertData[index].priority);
      //                         }}
      //                         className="cust-btn"
      //                     >
      //                         <img src={edit_icon} alt="" className="edit-btn" />
      //                     </button>
      //                 )}
      //             </div>
      //         );
      //     },
      // }
    ],
    [editIndex, tempPriority, alertData, page]
  );

  return (
    <div className="dashRightView ">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26">
          Total: {site ? alertData.length : 0}
        </h2>

        <div className="d-flex ac-jc">
          <h2 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 primary">
            Select Company
          </h2>
          <SelectBox
            arrayData={comapanyList}
            data={company}
            setData={setCompany}
            selectedOption={selectedItem}
            setSelectedOption={getSiteList}
            isClearable={false}
          />
        </div>

        <div className="d-flex ac-jc">
          <h2 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 primary">
            Select Site
          </h2>
          <SelectBox
            arrayData={siteList}
            data={data}
            setData={setData}
            selectedOption={site}
            setSelectedOption={getAlertTypes}
            disabled={!selectedItem?.label}
          />
        </div>
      </div>

      <TableAlert
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={alertData}
        show={true}
        selectedOption={site}
      />
    </div>
  );
};

export default AlertTypes;
